import { useForm, FormProvider } from "react-hook-form";

import { AddTouchpointsFromMondayTemplateContextProvider } from "components/modals/add-touchpoints-from-template-modal/context/add-touchpoints-from-monday-template-context";
import AddTouchpointsFromTemplateModalContent from "components/modals/add-touchpoints-from-template-modal/add-touchpoints-from-template-modal-content";

import type {
  AddTouchpointsFromMondayTemplateFormData,
  AddTouchpointsFromMondayTemplateModalProps,
} from "components/modals/add-touchpoints-from-template-modal/add-touchpoints-from-template-modal.types";

// Main component that provides the context and form
export const AddTouchpointsFromTemplateModal = ({
  setIsOpen = () => {},
  campaignObjective,
  folderId,
  onSuccess,
}: AddTouchpointsFromMondayTemplateModalProps) => {
  const methods = useForm<AddTouchpointsFromMondayTemplateFormData>({
    mode: "onChange",
    defaultValues: {
      strategy: "",
      populationType: "",
      campaignTemplates: [],
      templates: {},
    },
  });

  return (
    <AddTouchpointsFromMondayTemplateContextProvider
      setIsOpen={setIsOpen}
      campaignObjective={campaignObjective}
      folderId={folderId}
      onSuccess={onSuccess}>
      <FormProvider {...methods}>
        <AddTouchpointsFromTemplateModalContent />
      </FormProvider>
    </AddTouchpointsFromMondayTemplateContextProvider>
  );
};
